<template>
  <div class="workAddDemand">
    <el-form ref="workForm" class="workAddDemand_form" :model="workForm" :rules="WorkRules" label-width="120px">
      <!-- <el-form-item label="需求id" prop="demandId">
          <el-input v-model="workForm.demandId" placeholder="请输入需求id" />
        </el-form-item> -->
      <el-form-item label="项目" prop="projectId">
        <el-select v-model="workForm.projectId" placeholder="请选择项目">
          <el-option v-for="(item, index) in projectList" :key="index" :label="item.name" :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="负责人" prop="userName">
        <el-select v-model="workForm.userName" filterable remote reserve-keyword placeholder="请输入负责人名字"
          :remote-method="remoteMethod" :loading="remoteLoading" @change="userChange($event, 3)">
          <el-option v-for="(item, index) in userList" :key="index" :label="item.name" :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="计划开始时间" prop="planStartTime">
        <el-date-picker clearable v-model="workForm.planStartTime" type="date" value-format="yyyy-MM-dd"
          placeholder="请选择计划开始时间">
        </el-date-picker>
      </el-form-item>
      <el-form-item label="计划结束时间" prop="platEndTime">
        <el-date-picker clearable v-model="workForm.platEndTime" type="date" value-format="yyyy-MM-dd"
          placeholder="请选择计划结束时间">
        </el-date-picker>
      </el-form-item>
      <el-form-item label="项目文件" prop="files">
        <file-upload v-model="workForm.files" :limit="9" />
      </el-form-item>
    </el-form>
    <div class="btnBox">
      <el-button type="primary" class="btnBox_btn" @click="submitForm" :disabled="submitShow">确 定</el-button>
    </div>
  </div>
</template>

<script>
import { addOrder, listProject, listPersonnel } from '@/api/workOrder'
import Cookies from 'js-cookie'
export default {
  name: "workAddDemand",
  data() {
    return {
      // 表单参数
      workForm: {
        id: null,
        demandId: null,
        userId: null,
        userName: null,
        planStartTime: null,
        platEndTime: null,
        status: null,
        extensionMessage: null,
        files: null,
        wordFile: null,
        createTime: null,
        isUpdLog: 0
      },
      // 表单校验
      WorkRules: {
        projectId: [
          { required: true, message: "项目不能为空", trigger: "blur" }
        ],
        userName: [
          { required: true, message: "负责人不能为空", trigger: "blur" }
        ],
        planStartTime: [
          { required: true, message: "计划开始时间不能为空", trigger: "blur" }
        ],
        platEndTime: [
          { required: true, message: "计划结束时间不能为空", trigger: "blur" }
        ],
      },
      submitShow: false,
      projectList: [],
      userList: [],
      remoteLoading:false
    };
  },
  mounted() {
    console.log(this.$route.params)
    this.getProject()
  },
  methods: {
    getProject() {
      listProject({
        page: 1,
        limit: 999
      }).then(response => {
        this.projectList = response.rows;
      });
    },
    remoteMethod(query) {
      if (query !== '') {
        this.remoteloading = true;
        listPersonnel({
          pageNum: 1,
          pageSize: 999,
          name: query,
          companyId: this.$route.params.companyId
        }).then((response) => {
          this.userList = response.rows;
          console.log(response.row)
          this.remoteloading = false;
        });

      } else {
        this.userList = [];
      }
    },
    userChange(e, type) {
      console.log(e, type)
      const selectedOption = this.userList.find(option => option.id === e);
        this.workForm.phone = selectedOption.phone
        this.workForm.userName = selectedOption.name
        this.workForm.userId = selectedOption.userId
    },
    checkDate(selectedDate) {
      // 获取当前时间
      const today = new Date();
      // 将用户选择的时间转换为 Date 对象（注意格式兼容性）
      const selected = new Date(selectedDate);
      // 比较日期
      if (selected > today) {
        return 6;
      } else {
        return 1;
      }
    },
    /** 提交按钮 */
    submitForm() {
      this.submitShow = true
      this.$refs["workForm"].validate(valid => {
        if (valid) {
          this.workForm.companyId = this.$route.params.companyId
          this.workForm.demandId =  this.$route.params.id
          if (this.workForm.planStartTime) {
            this.workForm.status = this.checkDate(this.workForm.planStartTime)
          }
          addOrder(this.workForm).then(response => {
            this.$message({
              message: '提交成功',
              type: 'success'
            });
            setTimeout(() => {
              this.$router.go(-1)
              this.submitShow = false
            }, 3000); // 2000毫秒后显示消息
          });
        }
      });
    },
  },
};
</script>
<style scoped>
.workAddDemand {
  padding: 10px;
  padding-left: 0;
  height: 95vh;
}

.workAddDemand_form {
  width: calc(100% - 10px);
}

.colorBox {
  display: inline-block;
  width: 25px;
  height: 25px;
  border-radius: 3px;
  margin-right: 10px;
}

.colorBox_actived {
  border: 1px solid #000;
}

.btnBox {
  width: 100%;
  text-align: center;
  margin-top: 20px;
}

.btnBox_btn {
  width: 90%;
}
</style>
<style>
.workAddDemand .el-icon-document {
  width: auto !important;
}
</style>